export const appRoutes = {
  projects: {
    path: '/roles',
    url: () => '/roles',
  },
  companies: {
    path: '/companies',
    url: () => '/companies',
  },
  results: {
    path: '/results',
    url: () => '/results',
  },
  formManager: {
    path: '/form-manager',
    url: () => '/form-manager',
  },
  content: {
    path: '/skills',
    url: () => '/skills',
  },
  reports: {
    path: '/reports',
    url: () => '/reports',
  },
  users: {
    path: '/users',
    url: () => '/users',
  },
  integrations: {
    path: '/integrations',
    url: () => '/integrations',
  },
  docs: {
    path: '/docs',
    url: () => '/docs',
  },
};

export const docsRoutes = {
  page: {
    // `:slug` accepts a bare name or one with a `.md` suffix, which renders the
    // raw markdown instead of the formatted page.
    path: `${appRoutes.docs.path}/:slug`,
    url: (slug: string) => `${appRoutes.docs.path}/${slug}`,
  },
};

export const integrationsRoutes = {
  coderbyte: {
    path: `${appRoutes.integrations.path}/coderbyte`,
    url: () => `${appRoutes.integrations.path}/coderbyte`,
  },
  coderbyteWorkspace: {
    // The open workspace is a query param rather than a path segment: the
    // drawer sits over the list, so the list's own route stays current.
    url: (companyId: number) =>
      `${appRoutes.integrations.path}/coderbyte?companyId=${companyId}`,
  },
  kombo: {
    path: `${appRoutes.integrations.path}/kombo`,
    url: () => `${appRoutes.integrations.path}/kombo`,
  },
};

export const projectsRoutes = {
  createProject: {
    path: `${appRoutes.projects.path}/new-role`,
    url: () => `${appRoutes.projects.path}/new-role`,
  },
  editProjectView: {
    path: `${appRoutes.projects.path}/:projectId`,
    url: (projectId: number) => `${appRoutes.projects.path}/${projectId}`,
  },
};

export const companyRoutes = {
  createCompany: {
    path: `${appRoutes.companies.path}/new-company`,
    url: () => `${appRoutes.companies.path}/new-company`,
  },
  editCompany: {
    path: `${appRoutes.companies.path}/:companyId`,
    url: (companyId: number) => `${appRoutes.companies.path}/${companyId}`,
  },
};

export const editCompanyRoutes = {
  editCompanyRoles: {
    path: `${appRoutes.companies.path}/:companyId/company-roles`,
    url: (companyId: number) =>
      `${appRoutes.companies.path}/${companyId}/company-roles`,
  },
};

export const formManagerRoutes = {
  fields: {
    path: `${appRoutes.formManager.path}/fields`,
    url: () => `${appRoutes.formManager.path}/fields`,
  },
  companyForms: {
    path: `${appRoutes.formManager.path}/company-forms`,
    url: () => `${appRoutes.formManager.path}/company-forms`,
  },
  downloadSubmittedForms: {
    path: `${appRoutes.formManager.path}/download-submitted-forms`,
    url: () => `${appRoutes.formManager.path}/download-submitted-forms`,
  },
};

export const contentRoutes = {
  softSkills: {
    path: `${appRoutes.content.path}/soft-skills`,
    url: () => `${appRoutes.content.path}/soft-skills`,
  },
  traits: {
    path: `${appRoutes.content.path}/traits`,
    url: () => `${appRoutes.content.path}/traits`,
  },
  traitContent: {
    path: `${appRoutes.content.path}/trait-content`,
    url: () => `${appRoutes.content.path}/trait-content`,
  },
  interviewQuestionContent: {
    path: `${appRoutes.content.path}/interview-question-content`,
    url: () => `${appRoutes.content.path}/interview-question-content`,
  },
  technicalSkills: {
    path: `${appRoutes.content.path}/technical-skills`,
    url: () => `${appRoutes.content.path}/technical-skills`,
  },
  behaviourContent: {
    path: `${appRoutes.content.path}/behaviour-content`,
    url: () => `${appRoutes.content.path}/behaviour-content`,
  },
};

export const reportsRoutes = {
  reports: {
    path: `${appRoutes.reports.path}/report`,
    url: () => `${appRoutes.reports.path}/report`,
  },
  report: {
    path: `${appRoutes.reports.path}/report/:reportId`,
    url: (reportId: number) => `${appRoutes.reports.path}/report/${reportId}`,
  },
  widgets: {
    path: `${appRoutes.reports.path}/widgets`,
    url: () => `${appRoutes.reports.path}/widgets`,
  },
  widget: {
    path: `${appRoutes.reports.path}/widgets/:widgetId`,
    url: (widgetId: number) => `${appRoutes.reports.path}/widgets/${widgetId}`,
  },
};

export const usersRoutes = {
  user: {
    path: `${appRoutes.users.path}/:userId`,
    url: (userId: number) => `${appRoutes.users.path}/${userId}`,
  },
};

export const resultsRoutes = {
  candidateResults: {
    path: `${appRoutes.results.path}/candidate-results`,
    url: () => `${appRoutes.results.path}/candidate-results`,
  },
  candidateUsage: {
    path: `${appRoutes.results.path}/candidate-usage`,
    url: () => `${appRoutes.results.path}/candidate-usage`,
  },
  skillsValidated: {
    path: `${appRoutes.results.path}/skill-validated`,
    url: () => `${appRoutes.results.path}/skill-validated`,
  },
  users: {
    path: `${appRoutes.results.path}/users`,
    url: () => `${appRoutes.results.path}/users`,
  },
  QBRData: {
    path: `${appRoutes.results.path}/qbr-data`,
    url: () => `${appRoutes.results.path}/qbr-data`,
  },
};

export const jobRolesRoutes = {
  createJobRole: {
    path: `${appRoutes.projects.path}/job-role/new`,
    url: () => `${appRoutes.projects.url()}/job-role/new`,
  },
  editJobRole: {
    path: `${appRoutes.projects.path}/job-role/:jobRoleId`,
    url: (jobRoleId: number) =>
      `${appRoutes.projects.url()}/job-role/${jobRoleId}`,
  },
};

export const interviewGuideBlueprintRoutes = {
  blueprint: {
    path: '/interview-guide-blueprint/:subId',
    url: (subId: string) => `/interview-guide-blueprint/${subId}`,
  },
};

export const companyAppRoutes = {
  role: {
    path: `${import.meta.env.VITE_COMPANY_APP_BASE_URL}/roles/:projectId`,
    url: (projectId: string, workspaceId?: number) =>
      `${import.meta.env.VITE_COMPANY_APP_BASE_URL}/roles/${projectId}${
        workspaceId ? `?workspaceId=${workspaceId}` : ''
      }`,
  },
  candidateDrawer: {
    url: (
      projectId: number,
      meta: {
        stageId: number | null;
        userSubId: string | null;
        projectCandidateSubId: string | null;
        projectSubId: string | null;
      }
    ) => {
      const drawerMeta = [
        meta.stageId?.toString() ?? '',
        meta.userSubId ?? '',
        meta.projectCandidateSubId ?? '',
        meta.projectSubId ?? '',
      ].join('_');
      const params = new URLSearchParams({
        drawerType: 'candidate',
        drawerMeta,
      });
      return `${
        import.meta.env.VITE_COMPANY_APP_BASE_URL
      }/roles/${projectId}/candidates?${params.toString()}`;
    },
  },
};
